import React, { useEffect, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import Typography from '@nubank/nuds-web/components/Typography/Typography';

import useInView from '@nubank/www-latam-commons/utils/hooks/useInView';

import SectionRoot from './styles/SectionRoot';
import HeadingBlock from './styles/HeadingBlock';
import VideoDevice from './styles/VideoDevice';
import TextContentBlock from './styles/TextContentBlock';

function TotalControlSection({ index }) {
  const videoRef = useRef();

  const [inViewRef, isVisible] = useInView({
    intersectionOptions: {
      triggerOnce: true,
      rootMargin: '70px',
    },
  });

  const setRefs = useCallback(node => {
    videoRef.current = node;
    inViewRef(node);
  }, [inViewRef]);

  useEffect(() => {
    if (isVisible) {
      const $video = videoRef.current;
      $video.querySelectorAll('source')
        .forEach($source => ($source.setAttribute('src', $source.dataset.src)));
      $video.load();
    }
  }, [isVisible]);

  return (
    <SectionRoot
      minHeight="0px"
    >
      <HeadingBlock>
        <Typography
          variant="title"
          intlKey={`cms.businessAccountPage.cardsArea[${index}].title`}
        />
      </HeadingBlock>

      <VideoDevice
        loop
        muted
        autoPlay
        playsInline
        aria-hidden
        ref={setRefs}
      >
        <source data-src="/videos/pj/fluxo-device.webm" type="video/webm" />
        <source data-src="/videos/pj/fluxo-device.mp4" type="video/mp4" />
      </VideoDevice>

      <TextContentBlock>
        <Typography
          variant="subtitle"
          intlKey={`cms.businessAccountPage.cardsArea[${index}].description`}
        />
      </TextContentBlock>
    </SectionRoot>
  );
}

TotalControlSection.propTypes = {
  index: PropTypes.number.isRequired,
};

export default React.memo(TotalControlSection);
